import { render, staticRenderFns } from "./Contributor.vue?vue&type=template&id=58317bdc&scoped=true"
import script from "./Contributor.vue?vue&type=script&lang=js"
export * from "./Contributor.vue?vue&type=script&lang=js"
import style0 from "./Contributor.vue?vue&type=style&index=0&id=58317bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58317bdc",
  null
  
)

export default component.exports